import React, { useEffect, useState } from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import "../../styles/CustomModal.css";
import { KnockOrderItemType, SoldoutMenuType } from "../../recoil/type";
import { Option } from "../../controller/OrderController";

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  order: KnockOrderItemType;
  soldoutMenu: SoldoutMenuType[];
  setSoldoutMenu: (soldoutMenu: SoldoutMenuType[]) => void;
  setVisibleConfirm: () => void;
};

const SoldoutModal = ({
  isVisible,
  setVisible,
  order,
  soldoutMenu,
  setSoldoutMenu,
  setVisibleConfirm,
}: Props) => {
  const [menuList, setMenuList] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const onCloseModal = () => {
    setVisible(false);
  };

  const getMenuList = () => {
    setMenuList(order.child.detail.slice(currentPage * 4, currentPage * 4 + 4));
  };

  const CheckSoldoutMenu = (item: SoldoutMenuType) => {
    return (
      soldoutMenu.filter(
        (menu) =>
          menu.store_id === item.store_id && menu.product_id === item.product_id
      ).length > 0
    );
  };

  const SelectSoldoutMenu = (item: SoldoutMenuType) => {
    console.log("item", soldoutMenu, item);
    if (
      soldoutMenu.some(
        (menu) =>
          menu.store_id === item.store_id && menu.product_id === item.product_id
      )
    ) {
      const updatedList = soldoutMenu.filter(
        (menu) => menu.product_id !== item.product_id
      );
      setSoldoutMenu(updatedList);
    } else {
      setSoldoutMenu([...soldoutMenu, item]);
    }
  };

  const goNextPage = () => {
    if (order.child.detail.length > currentPage * 4 + 4) {
      setCurrentPage((prev) => prev + 1);
    }
  };
  const goPrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  useEffect(() => {
    if (isVisible) {
      setSoldoutMenu([]);
    }
    setCurrentPage(0);
  }, [isVisible]);

  useEffect(() => {
    getMenuList();
  }, [isVisible, currentPage]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "soldoutModalOverlay",
        modal: "soldoutModal",
      }}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
      showCloseIcon={true}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <h2>재료 소진 메뉴 선택</h2>
          <div className="listWrap">
            {menuList.map((item, index) => {
              const soldoutItem: SoldoutMenuType = {
                product_id: item.product_id,
                store_id: order.store_id,
                is_set: item.is_set,
              };
              return (
                <button
                  key={index}
                  className={`typeBox ${
                    CheckSoldoutMenu(soldoutItem) && "active"
                  }`}
                  onClick={() => SelectSoldoutMenu(soldoutItem)}
                >
                  <div className="boxWrap">
                    <h3>{item.product_name}</h3>
                    {item.options.map((option: Option, optIdx: number) => (
                      <h4 key={optIdx}>
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_linebreak_black.svg`}
                          alt="linebreak"
                        />
                        {option.option_name}
                      </h4>
                    ))}
                  </div>
                  {CheckSoldoutMenu(soldoutItem) && (
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_green.svg`}
                      alt="check"
                    />
                  )}
                </button>
              );
            })}
          </div>
          <div className="pageWrap">
            {currentPage > 0 ? (
              <button onClick={goPrevPage}>
                <img
                  src={`${
                    process.env.PUBLIC_URL
                  }/knockknock/svg/ic_arrow_left_${
                    order.child.detail.length < currentPage * 4 + 5
                      ? "grey"
                      : "black"
                  }.svg`}
                  alt="check"
                />
                <h4>이전</h4>
              </button>
            ) : (
              <div />
            )}
            <button
              className={`${
                order.child.detail.length < currentPage * 4 + 5 && "disabled"
              }`}
              onClick={goNextPage}
            >
              <h4>다음</h4>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_right_${
                  order.child.detail.length < currentPage * 4 + 5
                    ? "grey"
                    : "black"
                }.svg`}
                alt="check"
              />
            </button>
          </div>
          <div className="row gap">
            <button onClick={setVisibleConfirm}>완료</button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default SoldoutModal;

const Style = styled.div`
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    min-height: 50vh;
    padding: 5% 10%;
  }

  h2 {
    color: #333333;
    font-weight: 500;
    text-align: center;
  }

  .listWrap {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 24px 0 12px 0;
    gap: 10px;

    .typeBox {
      display: flex;
      justify-content: space-between;
      width: 100%;
      background-color: #fff;
      border: 1px solid #a7a7a7;
      border-radius: 10px;
      padding: 16px 30px 16px 16px;
      .boxWrap {
        display: flex;
        flex-direction: column;
        text-align: left;
        gap: 6px;
      }
      h3 {
        color: #333333;
        font-weight: 500;
      }
      h3.check {
        color: #4dd2ae;
        font-weight: 600;
      }
      h4 {
        margin-left: 4px;
        color: #333333;
        font-weight: 400;
        img {
          margin-right: 4px;
        }
      }
    }
    .typeBox.active {
      background: #ecf7f4;
      padding: 15px 29px 15px 15px;

      color: #4dd2ae;
      border: 2px solid #4dd2ae;
    }
  }

  .pageWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    button {
      padding: 8px 16px;
      border-radius: 50px;
      background-color: #fff;
      border: 1px solid #a7a7a7;
      display: flex;
      align-items: center;
      gap: 8px;
      h4 {
        color: #333333;
        font-weight: 500;
      }
      img {
        margin: 0 -4px;
        height: 20px;
      }
    }
    button.disabled {
      background-color: #efefef;
      h4 {
        color: #b2b2b2;
      }
    }
    button.disabled:hover {
      filter: none;
    }
  }

  .row.gap {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    button {
      flex: 1;
      text-align: center;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
      border-radius: 10px;
      padding: 12px 0;
      font-size: 24px;
      line-height: 30px;
      font-weight: 600;
      color: #ffffff;
    }
  }
`;
